import React from 'react';
import '../styles/Header.css';
import Logo from '../assets/ProInsight-Logo-new.png';

export default function Header() {
    return (
        <header className="logo-container">
            {/* {window.location.href.includes("propertyowner.proinsight") ? */}
                {!window.location.href.includes("apply.proinsight") && !window.location.href.includes("userId") && <img src="https://storage.googleapis.com/msgsndr/sIF5ZS1VxhUZsYbvq7gL/media/6880e057e69c95175b1aef66.png" alt="logo" />}
                {/* <img src={Logo} alt="logo" /> */}
        </header>
    )
}